gsap.registerPlugin(ScrollToPlugin);

// Fade Animations for every page
var fadeInElems = gsap.utils.toArray(".fade.fadeIn");
fadeInElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeUpElems = gsap.utils.toArray(".fade.fadeUp");
fadeUpElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        y: 15,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeLeftElems = gsap.utils.toArray(".fade.fadeLeft");
fadeLeftElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: -15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeRightElems = gsap.utils.toArray(".fade.fadeRight");
fadeRightElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: 15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

// Homepage Animations
window.initHomepageAnims = function () {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 991px", () =>{
        const introContent = document.querySelector(".intro .content");
        const introTL = gsap.timeline({
            scrollTrigger: {
                trigger: '.intro',
                scrub: true,
                pin: false,
            }
        });
        introTL.fromTo(introContent, {
            yPercent: 20,
            ease: "power1.inOut",
        }, {
            yPercent: -20,
            ease: "power1.inOut",
        });
        
        const aboutUsContent = document.querySelector(".about-us .content");
        const aboutUsInfo = document.querySelector(".about-us .information");
        const aboutTL = gsap.timeline({
            scrollTrigger: {
                trigger: '.about-us',
                scrub: true,
                pin: false,
            }
        });
        aboutTL.fromTo(aboutUsContent, {
            yPercent: 10,
            ease: "power1.inOut",
        }, {
            yPercent: -10,
            ease: "power1.inOut",
        });
        aboutTL.fromTo(aboutUsInfo, {
            yPercent: 25,
            ease: "power1.inOut",
        }, {
            yPercent: -25,
            ease: "power1.inOut",
        });

        const joinUsAsset = document.querySelector(".join-us .join-us-asset");
        const joinUsTL = gsap.timeline({
            scrollTrigger: {
                trigger: '.join-us',
                scrub: true,
                pin: false,
            }
        });
        joinUsTL.fromTo(joinUsAsset, {
            yPercent: 7,
            ease: "power1.inOut",
        }, {
            yPercent: -7,
            ease: "power1.inOut",
        });
    })
}